import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import DoubtSolutionPlayer from './DoubtSolutionPlayer';

const StyDoubtSolutionPlayer = styled(DoubtSolutionPlayer)`
  border-radius: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    border-radius: ${Spacings.SPACING_1B};
    height: 450px;
  }
`;

const RightBar = styled.div`
  grid-column: 1/15;
  display: flex;
  flex-direction: column;
  width: 100%;
  ${mediaQuery.uptoMobile} {
    align-items: center;
  }
`;

const SeeSolution = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    max-width: 360px;
  }
`;

const DoubtSolution = ({
  isSolutionAvailable,
  liveClassData,
  doubtUID,
  goalUID,
  selectedSolutionUID,
  onPlayerReady,
  recordingURL
}) => {
  return (
    <>
      <RightBar>
        {isSolutionAvailable ? (
          <SeeSolution>
            <StyDoubtSolutionPlayer
              liveClassData={liveClassData}
              doubtUID={doubtUID}
              solutionUID={selectedSolutionUID}
              goalUID={goalUID}
              onReady={onPlayerReady}
              recordingURL={recordingURL}
            />
          </SeeSolution>
        ) : null}
      </RightBar>
    </>
  );
};

export default DoubtSolution;
